import React from 'react';
import profileSkeletonSVGImage from '../assets/images/profile_skeleton.svg';

const ProfileSkeletonLoader = ({ modeClass }) => (
  <div style={{ textAlign: 'center', paddingTop: '40px', paddingBottom: '40px'}}>
    <div className={`wave-overlay ${modeClass}`}>
        <img src={profileSkeletonSVGImage} alt="Data Loading..." style={{ width: '40%' }} /><br />
    </div>
  </div>
);

export default ProfileSkeletonLoader;
